// extracted by mini-css-extract-plugin
module.exports = {"privacy-terms":"terms-and-conditions_privacy-terms__Sm3hS"};